// perhaps move to config, or notifications? TBD

export const HEATMAP_CALCULATION = 'CurrentRewardsAverage';
export const PAYSCALE_INCREASE_CALCULATION = 'PayscaleIncreaseCalculation';

export default {
  HEATMAP_CALCULATION,
  PAYSCALE_INCREASE_CALCULATION,
};
